import type { RouteRecordRaw } from "vue-router";

// Public routes — no auth required
export const businessAutomationPublicRoutes: RouteRecordRaw[] = [
  {
    path: "/p/:token",
    name: "PublicProspectForm",
    component: () =>
      import("@/views/BusinessAutomation/PublicProspectForm.vue"),
    props: true,
  },
  {
    path: "/proposal/:token",
    name: "PublicProposalView",
    component: () =>
      import("@/views/BusinessAutomation/PublicProposalView.vue"),
    props: true,
  },
  {
    path: "/prospect-form-submitted",
    name: "ProspectFormSubmitted",
    component: () =>
      import("@/views/BusinessAutomation/ProspectFormSubmitted.vue"),
  },
];

// Auth routes — inside the auth shell (requiresAuth inherited from parent)
export const businessAutomationAuthRoutes: RouteRecordRaw[] = [
  {
    path: "/business-automation",
    name: "business-automation",
    component: () =>
      import("@/views/BusinessAutomation/BusinessAutomation.vue"),
  },
  {
    path: "/prospect-client/:id?",
    name: "prospect-client",
    component: () => import("@/views/BusinessAutomation/ProspectClient.vue"),
  },
  {
    path: "/prospect-client-history/:id",
    name: "prospect-client-history",
    component: () =>
      import("@/views/BusinessAutomation/ProspectClientHistory.vue"),
    props: true,
  },
  {
    path: "/business-automation/proposal/:projectId",
    name: "business-automation-proposal",
    component: () =>
      import("@/views/BusinessAutomation/components/ProposalManagement.vue"),
    props: true,
  },
  {
    path: "/business-automation/engagement/:projectId",
    name: "business-automation-engagement",
    component: () =>
      import("@/views/BusinessAutomation/components/EngagementMemorandum.vue"),
    props: true,
  },
  {
    path: "/business-automation/pir/:projectId",
    name: "business-automation-pir",
    component: () =>
      import("@/views/BusinessAutomation/components/PIRReport.vue"),
    props: true,
  },
  {
    path: "/business-automation/press-release/:projectId",
    name: "business-automation-press-release",
    component: () =>
      import("@/views/BusinessAutomation/components/PressReleaseTemplate.vue"),
    props: true,
  },
  {
    path: "/business-automation/contact-database",
    name: "business-automation-contact-database",
    component: () =>
      import("@/views/BusinessAutomation/components/ContactDatabase.vue"),
  },
];
